import * as React                from 'react';
import { useTranslation }        from 'react-i18next';
import ReactPaginate             from 'react-paginate';
import { useLocation }           from 'react-router-dom';
import DV                        from 'ts-data-validator';
import { SessionStorageService } from 'ts-storage-service';

import Preloader                   from '../../../components/containers/preloader';
import Meta                        from '../../../components/meta';
import PaginationNextArrowIcon     from '../../../components/icons/PaginationNextArrowIcon';
import PaginationPreviousArrowIcon from '../../../components/icons/PaginationPreviosArrowIcon';
import PageHeader                  from '../../../components/pageHeader';

import Notfound from '../../notfound/components/Notfound';

import NewsItem from './NewsItem';
import TopNews  from './TopNews';

import { useCommon } from '../../../providers/common';
import { useNews }   from '../../../providers/news';

const News = function() {
  const location = useLocation();
  const { t }    = useTranslation();

  const common = useCommon();
  const news   = useNews();

  const ss = new SessionStorageService();

  const [savedPage, setSavedPage]     = React.useState(0);
  const [screenWidth, setScreenWidth] = React.useState(0);

  const imageBySize = React.useMemo(() => {
    if (screenWidth <= 990) {
      return 'image333x236';
    }

    return 'image320x240';
  }, [screenWidth]);
  const page        = React.useMemo(() => {
    return common.pages.find((page) => {
      return `/${page.urlKey}` === location.pathname;
    });
  }, [common.pages, location.pathname]);

  const headerProps = React.useMemo(() => {
    if (!DV.isString(page.headImage)) {
      return {
        transparent: false,
      };
    }

    return {
      transparent: true,
      bg:          page.headImage,
    };
  }, [page.headImage]);

  const handleClick  = React.useCallback((page) => {
    news.showMore(page, news.limit);

    setSavedPage(page);

    ss.setData('savedNewsPage', page);

    window.scrollTo({
      behavior: 'smooth',
      top:      0,
    });
  }, [news.limit]);
  const handleResize = React.useCallback(() => {
    setScreenWidth(window.innerWidth);
  }, []);

  React.useEffect(() => {
    const savedNewsPage = ss.getData('savedNewsPage');

    if (savedNewsPage) {
      handleClick(savedNewsPage);
    } else {
      news.getNewsList();

      scrollTo({
        left: 0,
        top:  0,
      });
    }
  }, []);
  React.useEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  if (!page) {
    return <Notfound />;
  }

  return (
    <>
      <div className={'news-page-content'}>
        <Meta {...page.meta} />
        {DV.isNotEmptyString(page.label) && <PageHeader {...headerProps}>{page.label}</PageHeader>}
        <main className={page.template}>
          <section className={'body'}>
            <div className={'container'}>
              <TopNews news={news.headItems} />
              <h2>{t('label_all_news')}</h2>
              <div className={'items_container'}>
                {news.items
                  .slice(-9)
                  .map((item, index) => {
                    return (
                      <NewsItem
                        activeFrom={item.activeFrom}
                        activeTo={item.activeTo}
                        date={item.createdAt}
                        image={item[imageBySize] || item.previewImage}
                        key={index}
                        label={item.label}
                        readingTime={item.readingTime}
                        type={item.newsTypeId}
                        urlKey={item.urlKey}
                      />
                    );
                  })}
              </div>
            </div>
          </section>
          <hr />
          <section className={'bottom'}>
            {!!news.count && (
              <ReactPaginate
                activeClassName={'active'}
                breakClassName={'page_item'}
                breakLabel={'...'}
                containerClassName={'pagination'}
                forcePage={savedPage}
                marginPagesDisplayed={2}
                nextLabel={(savedPage + 1) < ((news.count - 3) / 9) && <PaginationNextArrowIcon />}
                onPageChange={(currentPage) => {
                  handleClick(currentPage.selected);
                }}
                pageClassName={'page_item'}
                pageCount={Math.ceil((news.count - 3) / 9)}
                pageRangeDisplayed={3}
                previousLabel={savedPage !== 0 && <PaginationPreviousArrowIcon />}
                renderOnZeroPageCount={null}
              />
            )}
          </section>
        </main>
      </div>
      {(news.loading || news.loading) && <Preloader />}
    </>
  );
};

export default News;
